var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useMemo, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { Modal } from "@visiontrack/component-library";
import { useIntl } from "Intl";
import { Input, Label } from "Components.Form";
import { Loading } from "Components.Structure";
import styled, { useTheme } from "styled-components";
import { toast } from "react-toastify";
import { UtilitiesApi } from "Api";
var StyledModalForm = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var StyledFormGroup = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  input {\n    margin-top: 0.5rem;\n    padding: 1rem;\n    background: ", ";\n    border: 1px solid ", ";\n  }\n"], ["\n  input {\n    margin-top: 0.5rem;\n    padding: 1rem;\n    background: ", ";\n    border: 1px solid ", ";\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.grey[25]; });
var PasswordDisplay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 1.2rem;\n  text-align: center;\n"], ["\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 1.2rem;\n  text-align: center;\n"])), function (props) { return props.theme.colors.grey[10]; }, function (props) { return props.theme.colors.grey[25]; });
var ErrorMessage = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 1rem;\n  background: ", "33;\n  border-radius: 4px;\n  color: ", ";\n"], ["\n  padding: 1rem;\n  background: ", "33;\n  border-radius: 4px;\n  color: ", ";\n"])), function (props) { return props.theme.colors.red[0]; }, function (props) { return props.theme.colors.red[100]; });
var LoadingContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: 4rem;\n  right: 0;\n  left: 0;\n  bottom: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.8);\n"], ["\n  position: absolute;\n  top: 4rem;\n  right: 0;\n  left: 0;\n  bottom: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.8);\n"])));
var DevicePasswordModal = function (_a) {
    var isModalVisible = _a.isModalVisible, onCloseModal = _a.onCloseModal;
    var _b = useState(""), drid = _b[0], setDrid = _b[1];
    var _c = useState(""), serial = _c[0], setSerial = _c[1];
    var _d = useState(null), password = _d[0], setPassword = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(null), error = _f[0], setError = _f[1];
    var formatMessage = useIntl().formatMessage;
    var theme = useTheme();
    var utilitiesApi = useMemo(function () { return new UtilitiesApi(); }, []);
    var abortControllerRef = useRef(null);
    var handleFetchPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var signal, response, err_1, isAborted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    setError(null);
                    abortControllerRef.current = new AbortController();
                    signal = abortControllerRef.current.signal;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, utilitiesApi.getDevicePassword({
                            hardwareId: drid,
                            serialNumber: serial,
                        })];
                case 2:
                    response = _a.sent();
                    if (signal.aborted)
                        return [2 /*return*/];
                    if (!response.isSuccess) {
                        switch (response.status) {
                            case 204:
                                setError(formatMessage("devicePassword.error.noPassword"));
                                break;
                            case 404:
                                setError(formatMessage("devicePassword.error.notFound"));
                                break;
                            case 400:
                                setError(formatMessage("devicePassword.error.badRequest"));
                                break;
                            default:
                                setError(formatMessage("devicePassword.error.generic"));
                        }
                        return [2 /*return*/];
                    }
                    setPassword(response.payload.password);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    isAborted = err_1 instanceof DOMException && err_1.name === "AbortError";
                    if (isAborted || signal.aborted)
                        return [2 /*return*/];
                    console.error("Unexpected error fetching password:", err_1);
                    setError(formatMessage("devicePassword.error.generic"));
                    return [3 /*break*/, 5];
                case 4:
                    if (!signal.aborted)
                        setIsLoading(false);
                    abortControllerRef.current = null;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (password) {
                navigator.clipboard.writeText(password);
                toast.success(formatMessage("devicePassword.toast.copied"));
            }
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        if (abortControllerRef.current)
            abortControllerRef.current.abort();
        setDrid("");
        setSerial("");
        setPassword(null);
        setError(null);
        setIsLoading(false);
        onCloseModal();
    };
    var isFormValid = drid.trim() !== "" && serial.trim() !== "";
    var successActions = [
        {
            id: "devicePasswordModal_copy",
            key: "devicePasswordModal_copy",
            text: formatMessage("devicePassword.button.copy"),
            appearance: "positive",
            onClick: function () {
                handleCopyPassword();
            },
        },
        {
            id: "devicePasswordModal_close",
            key: "devicePasswordModal_close",
            text: formatMessage("devicePassword.button.close"),
            appearance: "default",
            onClick: handleClose,
        },
    ];
    var formActions = [
        {
            id: "devicePasswordModal_fetchPassword",
            key: "devicePasswordModal_fetchPassword",
            text: formatMessage("devicePassword.button.retrieve"),
            appearance: "default",
            onClick: function () {
                handleFetchPassword();
            },
            disabled: !isFormValid || isLoading,
        },
        {
            id: "devicePasswordModal_close",
            key: "devicePasswordModal_close",
            text: formatMessage("devicePassword.button.close"),
            appearance: "positive",
            onClick: handleClose,
        },
    ];
    var renderFormContent = function () { return (React.createElement(StyledModalForm, null,
        React.createElement("div", null,
            React.createElement("span", { id: "devicePasswordModal_dialogInfo1" },
                React.createElement(FormattedMessage, { id: 'devicePassword.info1' })),
            React.createElement("br", null),
            React.createElement("span", { id: "devicePasswordModal_dialogInfo2" },
                React.createElement(FormattedMessage, { id: 'devicePassword.info2' }))),
        React.createElement(StyledFormGroup, null,
            React.createElement(Label, { htmlFor: "devicePasswordModal_input_drid", id: "devicePasswordModal_input_drid_label" },
                React.createElement(FormattedMessage, { id: 'devicePassword.input.drid.label' })),
            React.createElement(Input, { id: "devicePasswordModal_input_drid", type: "text", value: drid, onChange: function (e) { return setDrid(e.target.value); }, placeholder: formatMessage("devicePassword.input.drid.placeholder"), disabled: isLoading })),
        React.createElement(StyledFormGroup, null,
            React.createElement(Label, { htmlFor: "devicePasswordModal_input_serial", id: "devicePasswordModal_input_serial_label" },
                React.createElement(FormattedMessage, { id: 'devicePassword.input.serial.label' })),
            React.createElement(Input, { id: "devicePasswordModal_input_serial", type: "text", value: serial, onChange: function (e) { return setSerial(e.target.value); }, placeholder: formatMessage("devicePassword.input.serial.placeholder"), disabled: isLoading })),
        error && React.createElement(ErrorMessage, { id: "devicePasswordModal_error" }, error),
        isLoading && (React.createElement(LoadingContainer, null,
            React.createElement(Loading, { barColor: theme.colors.blue[100], type: "spinner", includeText: false }))))); };
    var renderSuccessContent = function () { return (React.createElement(PasswordDisplay, { id: "devicePasswordModal_password_field" }, password)); };
    var modalContent = function () {
        if (password) {
            return renderSuccessContent();
        }
        return renderFormContent();
    };
    var modalActions = function () {
        if (password) {
            return successActions;
        }
        return formActions;
    };
    return (React.createElement(Modal, { isOpen: isModalVisible, onClose: handleClose, heading: formatMessage("devicePassword.header"), closeText: "", width: "small", actions: modalActions() }, modalContent()));
};
export default DevicePasswordModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
